'use client';

const contactMethods = [
  {
    icon: 'ri-phone-line',
    title: 'Phone Support',
    details: [
      '+91 8815239465',
      'Mon-Fri: 9AM-6PM',
      'Sat: 10AM-4PM'
    ],
    color: 'bg-green-100 text-green-600'
  },
  {
    icon: 'ri-mail-line',
    title: 'Email Support',
    details: [
      'nirvanaayurveda486@gmail.com',
      'Response within 24 hours',
      'Detailed assistance'
    ],
    color: 'bg-blue-100 text-blue-600'
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'WhatsApp',
    details: [
      '+91 8815239465',
      'Quick responses',
      'Product consultations'
    ],
    color: 'bg-emerald-100 text-emerald-600'
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Live Chat',
    details: [
      'Available on website',
      'Instant support',
      'Expert guidance'
    ],
    color: 'bg-purple-100 text-purple-600'
  }
];

const officeHours = [
  { day: 'Monday - Friday', hours: '9:00 AM - 6:00 PM' },
  { day: 'Saturday', hours: '10:00 AM - 4:00 PM' },
  { day: 'Sunday', hours: 'Closed' }
];

export default function ContactInfo() {
  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Get in Touch</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
          {contactMethods.map((method, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-4 sm:p-6 hover:shadow-xl transition-shadow duration-300">
              <div className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center ${method.color} rounded-full mb-3 sm:mb-4`}>
                <i className={`${method.icon} text-lg sm:text-xl`}></i>
              </div>
              
              <h3 className="font-bold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">{method.title}</h3>
              
              <div className="space-y-1">
                {method.details.map((detail, idx) => (
                  <p key={idx} className="text-gray-600 text-xs sm:text-sm">{detail}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 lg:p-8">
        <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6">Visit Our Office</h3>
        
        <div className="space-y-3 sm:space-y-4 mb-4 sm:mb-6">
          <div className="flex items-start space-x-3">
            <i className="ri-map-pin-line text-green-600 text-lg sm:text-xl mt-1"></i>
            <div>
              <div className="font-semibold text-gray-900 text-sm sm:text-base">Address</div>
              <div className="text-gray-600 text-sm sm:text-base">
              Hospital road <br/>Balvihar vidisha <br/>madhya pradesh 464001
              </div>
            </div>
          </div>
        </div>

        <div className="border-t pt-4 sm:pt-6">
          <h4 className="font-bold text-gray-900 mb-3 sm:mb-4 text-sm sm:text-base">Office Hours</h4>
          <div className="space-y-2">
            {officeHours.map((schedule, index) => (
              <div key={index} className="flex justify-between items-center">
                <span className="text-gray-700 text-xs sm:text-sm">{schedule.day}</span>
                <span className="text-gray-600 text-xs sm:text-sm">{schedule.hours}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-green-600 to-green-800 rounded-2xl p-4 sm:p-6 lg:p-8 text-white">
        <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Need Immediate Help?</h3>
        <p className="mb-4 sm:mb-6 opacity-90 text-sm sm:text-base">
          For urgent inquiries or emergency support, please call our hotline or 
          use our live chat feature for immediate assistance.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
  {/* Call Button */}
  <a
    href="tel:+918815239465"
    className="bg-white text-green-600 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold hover:bg-green-50 transition-colors text-center whitespace-nowrap text-sm sm:text-base"
  >
    Call Now
  </a>

  {/* WhatsApp Button */}
  <a
  href="https://wa.me/918815239465?text=Hi%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services"
  target="_blank"
  rel="noopener noreferrer"
  className="border-2 border-white text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold hover:bg-white hover:text-green-600 transition-all duration-300 whitespace-nowrap text-center text-sm sm:text-base"
>
  Start Live Chat
</a>
</div>
      </div>
    </div>
  );
}